import { useEffect, useState } from "react";

import {
  TextField, Typography
} from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

import { getUserById } from "../../api/User/UserApi";
import { ContentArea, FormCard, ToolbarTop } from "../../components";
import { User, UserRole } from "../../models/User";
import { userListUrl, userEditUrl } from "../../routes/routes";
import styles from "../SchoolYear/SchoolYearList.module.scss";

export function UserDetails() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();

  const createDefaultItem = (): User => {
    return {
      id: 0,
      oib: "",
      firstName: "",
      lastName: "",
      userRoles: [],
      oibValidated: false,
    };
  };
  const [item, setItem] = useState<User>(createDefaultItem());

  useEffect(() => {
    (async () => {
      if (!isNaN(+id) && +id > 0) {
        var result = (await getUserById(+id));
        if (result) {
          setItem(result);
        }
      }
    })();
  }, [id]);

  const goBack = () => {
    history.push(userListUrl());
  };
  const handleBackClicked = () => {
    goBack();
  };

  const handleEditClicked = () => {
    history.push(userEditUrl(+id));
  };

  const renderUserRoles = () => {
    if (item && item.userRoles && item.userRoles.length > 0) {
      return (
        <div>
          {item.userRoles.map(val =>
          (
            <div>
              {renderUserRole(val)}
              {renderLocations(val)}
              <div>&nbsp;</div>
            </div>
          )
          )}
        </div>
      )
    } else {
      return (<Row>
        <Col md={12} className={styles.emptyList}>
          <Typography variant="largeBold" component="h2">
            {t("common.noData")}
          </Typography>
        </Col>
      </Row>)
    }
  };
  const renderUserRole = (userRole: UserRole) => {
    return (
      <div>
        <Typography>
          {userRole.role.name}
        </Typography>
      </div>
    )
  };
  const renderLocations = (userRole: UserRole) => {
    if (userRole.locations && userRole.locations.length > 0) {
      return (
        <div>
          {userRole.locations.map(loc => (
            <Typography variant="small" component="p">
              {" - " + loc.name}
            </Typography>
          ))}
        </div>
      )
    }
  }

  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"hide"}
        showBack={"show"}
        showEdit={"show"}
        pageTitle={t("common.user.pageNameDetails")}
        onClickEdit={handleEditClicked}
        onClickBack={handleBackClicked}
      />
      <FormCard>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.user.oib")}
              name={"item.oib"}
              value={item.oib}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.user.lastName")}
              name={"item.lastName"}
              value={item.lastName}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.user.firstName")}
              name={"item.firstName"}
              value={item.firstName}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.email")}
              name={"item.email"}
              value={item.email}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.phone")}
              name={"item.telephone"}
              value={item.telephone}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Typography color="light">
              {t("common.user.roles")}
            </Typography>
          </Col>
        </Row>
        {renderUserRoles()}
      </FormCard>
    </ContentArea>
  );
}


